export default {
  state: () => ({
    active: false,
    counter: {
      active: false,
      time: 100000
    }
  }),
  getters: {
    loading_getActive: state => state.active,
    loading_getCounter: state => state.counter
  },
  mutations: {
    loading_setActive(state, value) {
      state.active = value;
    },
    loading_setCounter(state, value) {
      state.counter = value;
    }
  },
  actions: {
    loading_setActive({commit}, value) {
      commit('loading_setActive', value);
    },
    loading_setCounter({commit}, value) {
      commit('loading_setCounter', value);
    }
  }
}